export default __webpack_public_path__ + "static/patio-v4-6-bf93fafe8a56b4eb04bb9e942f244114.jpg";